import { Item } from "./ArticleItem.styled";

const ArticleItem = ({ href, onClick }) => {
  return <Item onClick={onClick}>{href}</Item>;
};

export default ArticleItem;
